import { render, staticRenderFns } from "./VoiceConfig.vue?vue&type=template&id=ad97caf0&scoped=true"
import script from "./VoiceConfig.vue?vue&type=script&lang=js"
export * from "./VoiceConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad97caf0",
  null
  
)

export default component.exports